import React, { createContext, useContext, useState, useCallback } from "react";
import LiveChatWindow from "@/components/LiveChatWindow";

const Ctx = createContext(null);

export function useLiveChat() {
  const v = useContext(Ctx);
  return v || { openChat: () => {} };
}

// App-root provider so a live chat persists across page navigation and can be
// minimized to a floating pill while the rest of the app stays usable.
export function LiveChatProvider({ children }) {
  const [userId, setUserId] = useState(null);
  const [minimized, setMinimized] = useState(false);

  const openChat = useCallback((uid) => { setUserId(uid); setMinimized(false); }, []);
  const minimize = useCallback(() => setMinimized(true), []);
  const restore = useCallback(() => setMinimized(false), []);
  const close = useCallback(() => { setUserId(null); setMinimized(false); }, []);

  return (
    <Ctx.Provider value={{ userId, minimized, openChat, minimize, restore, close }}>
      {children}
      {userId && (
        <LiveChatWindow
          key={userId}
          otherUserId={userId}
          minimized={minimized}
          onMinimize={minimize}
          onRestore={restore}
          onClose={close}
        />
      )}
    </Ctx.Provider>
  );
}
